'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _sagaUtils = require('@wh/saga-utils');

var _translationTokens = require('@wh/translation-tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build root saga from available sagas
 * @param {SagaType} localSagas Array to sagas to merge
 * @param {FilterType} filter Function to filter sagas
 * @returns {Function} Single saga composed of all the passed sagas
 * @private
 */
var buildRootSaga = function buildRootSaga(localSagas) {
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
    };
    return _regenerator2.default.mark(function sagasGenerator() {
        return _regenerator2.default.wrap(function sagasGenerator$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return localSagas.concat(_translationTokens.sagas).filter(function (saga) {
                            return filter((0, _sagaUtils.getSagaTarget)(saga));
                        }).map(function (saga) {
                            return (0, _effects.fork)(saga);
                        });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, sagasGenerator, this);
    });
};

exports.default = buildRootSaga;
//# sourceMappingURL=buildSagas.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/buildSagas.js
// module id = 268
// module chunks = 0